import axiosHandler from '../axiosInterceptors';
import { FETCH_REVOCATION_DATA, CREATE_REVOCATION_DATA, UPDATE_REVOCATION_DATA, DELETE_REVOCATION_DATA, FETCH_REVOCATION_GLOBAL_SEARCH_DATA, FETCH_CRL_SIGNER_CERTIFICATE, PUBLISH_PKI_DCL, UPDATE_PKI_DCL, DELETE_PKI_DCL, FETCH_CRL_LABEL_FROM_PAI_DATA, DOWNLOAD_REVOK } from '../constants/urls';
import setAuthHeader from './AuthHeader';
// Call the setAuthHeader function to set the Authorization header
setAuthHeader();

export async function fetchRevocationData() {
    try{
        const resp = await axiosHandler.get(FETCH_REVOCATION_DATA);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function fetchRevocationGlobalSearchData(data) {
    try{
        const resp = await axiosHandler.post(FETCH_REVOCATION_GLOBAL_SEARCH_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function createRevocationData(data) {
    try{
        const resp = await axiosHandler.post(CREATE_REVOCATION_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function updateRevocationData(data) {
    try{
        const resp = await axiosHandler.patch(UPDATE_REVOCATION_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function deleteRevocationData(data) {
    try{
        const resp = await axiosHandler.delete(DELETE_REVOCATION_DATA + `?id=${data.id}`);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}


// export async function uploadRevocation(fileData){
//     try{
//         const resp = await axiosHandler.post(UPLOAD_DOCUMENT_DATA, fileData, {headers: {'content-Type': 'multipart/form-data'}});
//         return resp;
//     }
//     catch(error){
//         throw new Error('Error uploading document' + error.message)
//     }
// }

export async function fetchCrlSignerCertificateData() {
    try{
        const resp = await axiosHandler.get(FETCH_CRL_SIGNER_CERTIFICATE);
        return resp;
    }
    catch(error){
        throw error.response.data;
    }
}

export async function publishRevocationDCL(data, source) {
    try{
        const resp = await axiosHandler.post(PUBLISH_PKI_DCL + `?source=${source}`, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function updateRevocationDCL(data, source) {
    try{
        const resp = await axiosHandler.patch(UPDATE_PKI_DCL + `?source=${source}`, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function deleteRevocationDCL(data, source) {
    try{
        const resp = await axiosHandler.post(DELETE_PKI_DCL + `?source=${source}`, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function fetchCRLLabelFromPAI(data) {
    try{
        const resp = await axiosHandler.post(FETCH_CRL_LABEL_FROM_PAI_DATA, data, {responseType: 'blob'});
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function downloadRevok(data) {
    try{
        const resp = await axiosHandler.post(DOWNLOAD_REVOK, data, {responseType: 'blob'});
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}
